import type { DocsService } from '@ofuro/core/modules/doc';
import { Service } from '@toeverything/infra';
import { map, type Observable } from 'rxjs';

import type { GroupByProvider } from '../../provider';
import type { GroupByParams } from '../../types';

export class DocPrimaryModeGroupByProvider
  extends Service
  implements GroupByProvider
{
  constructor(private readonly docsService: DocsService) {
    super();
  }

  groupBy$(
    _items$: Observable<Set<string>>,
    _params: GroupByParams
  ): Observable<Map<string, Set<string>>> {
    return this.docsService.propertyValues$('primaryMode').pipe(
      map(values => {
        const result = new Map<string, Set<string>>();
        for (const [id, value] of values) {
          const mode = value ?? 'page';
          if (!result.has(mode)) {
            result.set(mode, new Set([id]));
          } else {
            result.get(mode)?.add(id);
          }
        }
        return result;
      })
    );
  }
}
